module.exports = __webpack_public_path__ + "static/media/invoice_active.4b32ae01.svg";